import React, { useState } from 'react'

const rerenders = new WeakMap<React.Dispatch<React.SetStateAction<object>>, () => void>()

export default function useRerender() {
  const [, doRerender] = useState<object>()
  if (!rerenders.has(doRerender)) {
    rerenders.set(doRerender, () => doRerender({}))
  }
  return rerenders.get(doRerender)
}
